import { render, staticRenderFns } from "./emrClass.vue?vue&type=template&id=32760154&scoped=true&"
import script from "./emrClass.vue?vue&type=script&lang=js&"
export * from "./emrClass.vue?vue&type=script&lang=js&"
import style0 from "./emrClass.vue?vue&type=style&index=0&id=32760154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32760154",
  null
  
)

export default component.exports